'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Decimal = require('decimal.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Decimal__default = /*#__PURE__*/_interopDefaultLegacy(Decimal);

var salesforceParser = // Generated by Peggy 3.0.2.
//
// https://peggyjs.org/
(function() {

function peg$subclass(child, parent) {
  function C() { this.constructor = child; }
  C.prototype = parent.prototype;
  child.prototype = new C();
}

function peg$SyntaxError(message, expected, found, location) {
  var self = Error.call(this, message);
  // istanbul ignore next Check is a necessary evil to support older environments
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(self, peg$SyntaxError.prototype);
  }
  self.expected = expected;
  self.found = found;
  self.location = location;
  self.name = "SyntaxError";
  return self;
}

peg$subclass(peg$SyntaxError, Error);

function peg$padEnd(str, targetLength, padString) {
  padString = padString || " ";
  if (str.length > targetLength) { return str; }
  targetLength -= str.length;
  padString += padString.repeat(targetLength);
  return str + padString.slice(0, targetLength);
}

peg$SyntaxError.prototype.format = function(sources) {
  var str = "Error: " + this.message;
  if (this.location) {
    var src = null;
    var k;
    for (k = 0; k < sources.length; k++) {
      if (sources[k].source === this.location.source) {
        src = sources[k].text.split(/\r\n|\n|\r/g);
        break;
      }
    }
    var s = this.location.start;
    var offset_s = (this.location.source && (typeof this.location.source.offset === "function"))
      ? this.location.source.offset(s)
      : s;
    var loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
    if (src) {
      var e = this.location.end;
      var filler = peg$padEnd("", offset_s.line.toString().length, ' ');
      var line = src[s.line - 1];
      var last = s.line === e.line ? e.column : line.length + 1;
      var hatLen = (last - s.column) || 1;
      str += "\n --> " + loc + "\n"
          + filler + " |\n"
          + offset_s.line + " | " + line + "\n"
          + filler + " | " + peg$padEnd("", s.column - 1, ' ')
          + peg$padEnd("", hatLen, "^");
    } else {
      str += "\n at " + loc;
    }
  }
  return str;
};

peg$SyntaxError.buildMessage = function(expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function(expectation) {
      return "\"" + literalEscape(expectation.text) + "\"";
    },

    class: function(expectation) {
      var escapedParts = expectation.parts.map(function(part) {
        return Array.isArray(part)
          ? classEscape(part[0]) + "-" + classEscape(part[1])
          : classEscape(part);
      });

      return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]";
    },

    any: function() {
      return "any character";
    },

    end: function() {
      return "end of input";
    },

    other: function(expectation) {
      return expectation.description;
    }
  };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s
      .replace(/\\/g, "\\\\")
      .replace(/"/g,  "\\\"")
      .replace(/\0/g, "\\0")
      .replace(/\t/g, "\\t")
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r")
      .replace(/[\x00-\x0F]/g,          function(ch) { return "\\x0" + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return "\\x"  + hex(ch); });
  }

  function classEscape(s) {
    return s
      .replace(/\\/g, "\\\\")
      .replace(/\]/g, "\\]")
      .replace(/\^/g, "\\^")
      .replace(/-/g,  "\\-")
      .replace(/\0/g, "\\0")
      .replace(/\t/g, "\\t")
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r")
      .replace(/[\x00-\x0F]/g,          function(ch) { return "\\x0" + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return "\\x"  + hex(ch); });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = expected.map(describeExpectation);
    var i, j;

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ")
          + ", or "
          + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== undefined ? options : {};

  var peg$FAILED = {};
  var peg$source = options.grammarSource;

  var peg$startRuleFunctions = { start: peg$parsestart };
  var peg$startRuleFunction = peg$parsestart;

  var peg$c0 = "(";
  var peg$c1 = ")";
  var peg$c2 = "^";
  var peg$c3 = "*";
  var peg$c4 = "/";
  var peg$c5 = "+";
  var peg$c6 = "-";
  var peg$c7 = "<=";
  var peg$c8 = ">=";
  var peg$c9 = "<>";
  var peg$c10 = "<";
  var peg$c11 = ">";
  var peg$c12 = "==";
  var peg$c13 = "=";
  var peg$c14 = "!=";
  var peg$c15 = "&&";
  var peg$c16 = "||";
  var peg$c17 = "&";
  var peg$c18 = "!";
  var peg$c20 = "_";
  var peg$c21 = "$";
  var peg$c22 = "[";
  var peg$c23 = ".";
  var peg$c24 = "]";
  var peg$c25 = "0";
  var peg$c26 = "true";
  var peg$c27 = "false";
  var peg$c28 = "null";
  var peg$c29 = "\\";
  var peg$c30 = "'";
  var peg$c31 = "\"";
  var peg$c32 = "\t";
  var peg$c33 = "\v";
  var peg$c34 = "\f";
  var peg$c35 = " ";
  var peg$c36 = "\xA0";
  var peg$c37 = "\u200B";
  var peg$c38 = "\uFEFF";

  var peg$r0 = /^[A-Za-z]/;
  var peg$r1 = /^[0-9]/;
  var peg$r2 = /^[1-9]/;
  var peg$r3 = /^[\n\r\u2028\u2029]/;

  var peg$e0 = peg$literalExpectation("(", false);
  var peg$e1 = peg$literalExpectation(")", false);
  var peg$e2 = peg$literalExpectation("^", false);
  var peg$e3 = peg$literalExpectation("*", false);
  var peg$e4 = peg$literalExpectation("/", false);
  var peg$e5 = peg$literalExpectation("+", false);
  var peg$e6 = peg$literalExpectation("-", false);
  var peg$e7 = peg$literalExpectation("<=", false);
  var peg$e8 = peg$literalExpectation(">=", false);
  var peg$e9 = peg$literalExpectation("<>", false);
  var peg$e10 = peg$literalExpectation("<", false);
  var peg$e11 = peg$literalExpectation(">", false);
  var peg$e12 = peg$literalExpectation("==", false);
  var peg$e13 = peg$literalExpectation("=", false);
  var peg$e14 = peg$literalExpectation("!=", false);
  var peg$e15 = peg$literalExpectation("&&", false);
  var peg$e16 = peg$literalExpectation("||", false);
  var peg$e17 = peg$literalExpectation("&", false);
  var peg$e18 = peg$literalExpectation("!", false);
  var peg$e19 = peg$literalExpectation(",", false);
  var peg$e20 = peg$classExpectation([["A", "Z"], ["a", "z"]], false, false);
  var peg$e21 = peg$literalExpectation("_", false);
  var peg$e22 = peg$literalExpectation("$", false);
  var peg$e23 = peg$literalExpectation("[", false);
  var peg$e24 = peg$literalExpectation(".", false);
  var peg$e25 = peg$literalExpectation("]", false);
  var peg$e26 = peg$literalExpectation("0", false);
  var peg$e27 = peg$classExpectation([["0", "9"]], false, false);
  var peg$e28 = peg$classExpectation([["1", "9"]], false, false);
  var peg$e29 = peg$literalExpectation("true", true);
  var peg$e30 = peg$literalExpectation("false", true);
  var peg$e31 = peg$literalExpectation("null", true);
  var peg$e32 = peg$literalExpectation("\\", false);
  var peg$e33 = peg$literalExpectation("'", false);
  var peg$e34 = peg$literalExpectation("\"", false);
  var peg$e35 = peg$anyExpectation();
  var peg$e36 = peg$classExpectation(["\n", "\r", "\u2028", "\u2029"], false, false);
  var peg$e37 = peg$literalExpectation("\t", false);
  var peg$e38 = peg$literalExpectation("\v", false);
  var peg$e39 = peg$literalExpectation("\f", false);
  var peg$e40 = peg$literalExpectation(" ", false);
  var peg$e41 = peg$literalExpectation("\xA0", false);
  var peg$e42 = peg$literalExpectation("\u200B", false);
  var peg$e43 = peg$literalExpectation("\uFEFF", false);

  var peg$f0 = function(expression) { return expression; };
  var peg$f1 = function(expression) { return expression; };
  var peg$f2 = function(id, args) {
    return {
      type: "callExpression",
      id: id,
      arguments: optionalList(args)
    }
  };
  var peg$f3 = function(head, tail) {
    return infixToPostfixAst([head, tail].flat(2))
  };
  var peg$f4 = function(op, expr) {
    return [Object.assign({ type: 'operator' }, operators[op]), expr]
  };
  var peg$f5 = function(op, expr) {
  return [op, expr]; 
 };
  var peg$f6 = function(head, tail) {
    var asOperators = tail.map(function(element) {
      var op = element[0];

      return [
        Object.assign({ type: 'operator' }, operators[op]),
        element[1],
      ]
    });

    return infixToPostfixAst([head, asOperators].flat(2))
  };
  var peg$f7 = function(head, op, tail) {
    var name;
    switch(op) {
      case "<":
        name = "lessThan";
        break;
      case "<=":
        name = "lessThanOrEqual";
        break;
      case ">":
        name = "greaterThan";
        break;
      case ">=":
        name = "greaterThanOrEqual";
        break;
      case "==":
      case "=":
        name = "equal";
        break;
      case "!=":
      case "<>":
        name = "unequal";
        break;
      case "&":
        name = "add";
        break;
    }

    return {
      type: "callExpression",
      id: name,
      arguments: [head, tail]
    }
  };
  var peg$f8 = function(tail) {
    return {
      type: "callExpression",
      id: "not",
      arguments: [tail]
    }
  };
  var peg$f9 = function(args) {
      return args;
    };
  var peg$f10 = function(arg) {
      return arg;
    };
  var peg$f11 = function(args) {
    return args;
  };
  var peg$f12 = function(id) { return id.join("").toLowerCase(); };
  var peg$f13 = function(name) { return name; };
  var peg$f14 = function(head, tail) {
      return {
        type: "identifier",
        name: head + tail.join("")
      };
    };
  var peg$f15 = function(chars) { return stringLiteral(chars); };
  var peg$f16 = function(chars) { return stringLiteral(chars); };
  var peg$f17 = function(sign) {
      var splitted = text().replace(/[\+\-]/g, "").split(".");
      return {
        type: "literal",
        value: parseFloat(text()),
        dataType: "number",
        options: {
          length: splitted[0].length,
          scale: splitted[1].length,
        }
      };
    };
  var peg$f18 = function(sign) {
      return {
        type: "literal",
        value: parseInt(text()),
        dataType: "number",
        options: {
          length: text().replace(/[\+\-]/g, "").length,
          scale: 0,
        }
      };
  };
  var peg$f19 = function() {
    return {
      type: "literal",
      value: true,
      dataType: "checkbox",
      options: {}
    }
  };
  var peg$f20 = function() {
    return {
      type: "literal",
      value: false,
      dataType: "checkbox",
      options: {}
    }
  };
  var peg$f21 = function() {
    return {
      type: "literal",
      value: null,
      dataType: "null",
      options: {}
    }
  };
  var peg$f22 = function() { return text(); };
  var peg$currPos = 0;
  var peg$savedPos = 0;
  var peg$posDetailsCache = [{ line: 1, column: 1 }];
  var peg$maxFailPos = 0;
  var peg$maxFailExpected = [];
  var peg$silentFails = 0;

  var peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text: text, ignoreCase: ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos];
    var p;

    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;

      return details;
    }
  }

  function peg$computeLocation(startPos, endPos, offset) {
    var startPosDetails = peg$computePosDetails(startPos);
    var endPosDetails = peg$computePosDetails(endPos);

    var res = {
      source: peg$source,
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
    if (offset && peg$source && (typeof peg$source.offset === "function")) {
      res.start = peg$source.offset(res.start);
      res.end = peg$source.offset(res.end);
    }
    return res;
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parsestart() {
    var s0;

    s0 = peg$parsePrimaryExpression();

    return s0;
  }

  function peg$parsePrimaryExpression() {
    var s0;

    s0 = peg$parseLogicalConcatenationExpression();
    if (s0 === peg$FAILED) {
      s0 = peg$parseUnaryExpression();
      if (s0 === peg$FAILED) {
        s0 = peg$parseCallExpression();
        if (s0 === peg$FAILED) {
          s0 = peg$parseIdentifier();
          if (s0 === peg$FAILED) {
            s0 = peg$parseLiteral();
          }
        }
      }
    }

    return s0;
  }

  function peg$parseTerm() {
    var s0;

    s0 = peg$parseCallExpression();
    if (s0 === peg$FAILED) {
      s0 = peg$parseIdentifier();
      if (s0 === peg$FAILED) {
        s0 = peg$parseLiteral();
        if (s0 === peg$FAILED) {
          s0 = peg$parseParenthesizedExpression();
        }
      }
    }

    return s0;
  }

  function peg$parseParenthesizedExpression() {
    var s0, s1, s3, s5;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 40) {
      s1 = peg$c0;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e0); }
    }
    if (s1 !== peg$FAILED) {
      peg$parse__();
      s3 = peg$parseArithmeticExpression();
      if (s3 !== peg$FAILED) {
        peg$parse__();
        if (input.charCodeAt(peg$currPos) === 41) {
          s5 = peg$c1;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e1); }
        }
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f0(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 40) {
        s1 = peg$c0;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e0); }
      }
      if (s1 !== peg$FAILED) {
        peg$parse__();
        s3 = peg$parseLogicalConcatenationExpression();
        if (s3 !== peg$FAILED) {
          peg$parse__();
          if (input.charCodeAt(peg$currPos) === 41) {
            s5 = peg$c1;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e1); }
          }
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f1(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseCallExpression() {
    var s0, s1, s3;

    s0 = peg$currPos;
    s1 = peg$parseFunctionIdentifier();
    if (s1 !== peg$FAILED) {
      peg$parse__();
      s3 = peg$parseArguments();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f2(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseArithmeticExpression() {
    var s0, s1, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parseTerm();
    if (s1 !== peg$FAILED) {
      peg$parse__();
      s3 = [];
      s4 = peg$parseArithmeticPart();
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        s4 = peg$parseArithmeticPart();
      }
      peg$savedPos = s0;
      s0 = peg$f3(s1, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseArithmeticPart() {
    var s0, s2, s4;

    s0 = peg$currPos;
    peg$parse__();
    s2 = peg$parseArithmeticOperator();
    if (s2 !== peg$FAILED) {
      peg$parse__();
      s4 = peg$parseTerm();
      if (s4 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f4(s2, s4);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseArithmeticOperator() {
    var s0;

    if (input.charCodeAt(peg$currPos) === 94) {
      s0 = peg$c2;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e2); }
    }
    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 42) {
        s0 = peg$c3;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e3); }
      }
      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 47) {
          s0 = peg$c4;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e4); }
        }
        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 43) {
            s0 = peg$c5;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e5); }
          }
          if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 45) {
              s0 = peg$c6;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e6); }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseLogicalTerm() {
    var s0, s2, s4;

    s0 = peg$currPos;
    peg$parse__();
    s2 = peg$parseLogicalConcatenationOperator();
    if (s2 !== peg$FAILED) {
      peg$parse__();
      s4 = peg$parseLogicalCompareExpression();
      if (s4 === peg$FAILED) {
        s4 = peg$parseUnaryExpression();
      }
      if (s4 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f5(s2, s4);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLogicalConcatenationExpression() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseLogicalCompareExpression();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseLogicalTerm();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseLogicalTerm();
      }
      peg$savedPos = s0;
      s0 = peg$f6(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseLogicalCompareExpression() {
    var s0, s1, s3, s5;

    s0 = peg$currPos;
    s1 = peg$parseArithmeticExpression();
    if (s1 !== peg$FAILED) {
      peg$parse__();
      s3 = peg$parseLogicalCompareOperator();
      if (s3 === peg$FAILED) {
        s3 = peg$parseConcatenationOperator();
      }
      if (s3 !== peg$FAILED) {
        peg$parse__();
        s5 = peg$parseLogicalCompareExpression();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f7(s1, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseArithmeticExpression();
    }

    return s0;
  }

  function peg$parseLogicalCompareOperator() {
    var s0;

    if (input.substr(peg$currPos, 2) === peg$c7) {
      s0 = peg$c7;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e7); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c8) {
        s0 = peg$c8;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e8); }
      }
      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c9) {
          s0 = peg$c9;
          peg$currPos += 2;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e9); }
        }
        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 60) {
            s0 = peg$c10;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e10); }
          }
          if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 62) {
              s0 = peg$c11;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e11); }
            }
            if (s0 === peg$FAILED) {
              if (input.substr(peg$currPos, 2) === peg$c12) {
                s0 = peg$c12;
                peg$currPos += 2;
              } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e12); }
              }
              if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 61) {
                  s0 = peg$c13;
                  peg$currPos++;
                } else {
                  s0 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$e13); }
                }
                if (s0 === peg$FAILED) {
                  if (input.substr(peg$currPos, 2) === peg$c14) {
                    s0 = peg$c14;
                    peg$currPos += 2;
                  } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$e14); }
                  }
                }
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseLogicalConcatenationOperator() {
    var s0;

    if (input.substr(peg$currPos, 2) === peg$c15) {
      s0 = peg$c15;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e15); }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 2) === peg$c16) {
        s0 = peg$c16;
        peg$currPos += 2;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e16); }
      }
    }

    return s0;
  }

  function peg$parseConcatenationOperator() {
    var s0;

    if (input.charCodeAt(peg$currPos) === 38) {
      s0 = peg$c17;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e17); }
    }

    return s0;
  }

  function peg$parseUnaryExpression() {
    var s0, s1, s3;

    s0 = peg$currPos;
    s1 = peg$parseUnaryOperator();
    if (s1 !== peg$FAILED) {
      peg$parse__();
      s3 = peg$parsePrimaryExpression();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f8(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseUnaryOperator() {
    var s0;

    if (input.charCodeAt(peg$currPos) === 33) {
      s0 = peg$c18;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e18); }
    }

    return s0;
  }

  function peg$parseArguments() {
    var s0, s1, s3, s4, s5;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 40) {
      s1 = peg$c0;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e0); }
    }
    if (s1 !== peg$FAILED) {
      peg$parse__();
      s3 = peg$currPos;
      s4 = peg$parseArgumentList();
      if (s4 !== peg$FAILED) {
        s5 = peg$parse__();
        s4 = [s4, s5];
        s3 = s4;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      if (input.charCodeAt(peg$currPos) === 41) {
        s4 = peg$c1;
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e1); }
      }
      if (s4 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f9(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseArgumentList() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$currPos;
    s3 = peg$parseFunctionArgument();
    if (s3 !== peg$FAILED) {
      peg$parse__();
      if (input.charCodeAt(peg$currPos) === 44) {
        peg$currPos++;
      } else {
        if (peg$silentFails === 0) { peg$fail(peg$e19); }
      }
      peg$parse__();
      peg$savedPos = s2;
      s2 = peg$f10(s3);
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$currPos;
        s3 = peg$parseFunctionArgument();
        if (s3 !== peg$FAILED) {
          peg$parse__();
          if (input.charCodeAt(peg$currPos) === 44) {
            peg$currPos++;
          } else {
            if (peg$silentFails === 0) { peg$fail(peg$e19); }
          }
          peg$parse__();
          peg$savedPos = s2;
          s2 = peg$f10(s3);
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f11(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseFunctionArgument() {
    var s0;

    s0 = peg$parseLogicalConcatenationExpression();
    if (s0 === peg$FAILED) {
      s0 = peg$parseUnaryExpression();
      if (s0 === peg$FAILED) {
        s0 = peg$parseCallExpression();
        if (s0 === peg$FAILED) {
          s0 = peg$parseIdentifier();
          if (s0 === peg$FAILED) {
            s0 = peg$parseLiteral();
          }
        }
      }
    }

    return s0;
  }

  function peg$parseFunctionIdentifier() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    if (peg$r0.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e20); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        if (peg$r0.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e20); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f12(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseIdentifier() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$parseReservedKeyword();
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseIdentifierName();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f13(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseIdentifierName() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseIdentifierStart();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseIdentifierPart();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseIdentifierPart();
      }
      peg$savedPos = s0;
      s0 = peg$f14(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseIdentifierStart() {
    var s0;

    if (input.charCodeAt(peg$currPos) === 95) {
      s0 = peg$c20;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e21); }
    }
    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 36) {
        s0 = peg$c21;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e22); }
      }
      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 91) {
          s0 = peg$c22;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e23); }
        }
        if (s0 === peg$FAILED) {
          if (peg$r0.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e20); }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseIdentifierPart() {
    var s0;

    s0 = peg$parseIdentifierStart();
    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 46) {
        s0 = peg$c23;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e24); }
      }
      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 93) {
          s0 = peg$c24;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e25); }
        }
        if (s0 === peg$FAILED) {
          s0 = peg$parseDecimalDigit();
        }
      }
    }

    return s0;
  }

  function peg$parseLiteral() {
    var s0;

    s0 = peg$parseStringLiteral();
    if (s0 === peg$FAILED) {
      s0 = peg$parseDecimalLiteral();
      if (s0 === peg$FAILED) {
        s0 = peg$parseBooleanLiteral();
        if (s0 === peg$FAILED) {
          s0 = peg$parseNullLiteral();
        }
      }
    }

    return s0;
  }

  function peg$parseStringLiteral() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseSingleQuote();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseCharacter();
      if (s3 === peg$FAILED) {
        s3 = peg$parseDoubleQuote();
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseCharacter();
        if (s3 === peg$FAILED) {
          s3 = peg$parseDoubleQuote();
        }
      }
      s3 = peg$parseSingleQuote();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f15(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseDoubleQuote();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parseCharacter();
        if (s3 === peg$FAILED) {
          s3 = peg$parseSingleQuote();
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseCharacter();
          if (s3 === peg$FAILED) {
            s3 = peg$parseSingleQuote();
          }
        }
        s3 = peg$parseDoubleQuote();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f16(s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseDecimalLiteral() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parse__();
    if (input.charCodeAt(peg$currPos) === 43) {
      s3 = peg$c5;
      peg$currPos++;
    } else {
      s3 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e5); }
    }
    if (s3 !== peg$FAILED) {
      s2 = [s2, s3];
      s1 = s2;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 === peg$FAILED) {
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 45) {
        s2 = peg$c6;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e6); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s2 = [s2, s3];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    }
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parseDecimalIntegerLiteral();
    if (s2 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 46) {
        s3 = peg$c23;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e24); }
      }
      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$parseDecimalDigit();
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$parseDecimalDigit();
        }
        peg$savedPos = s0;
        s0 = peg$f17();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$currPos;
      s2 = peg$parse__();
      if (input.charCodeAt(peg$currPos) === 43) {
        s3 = peg$c5;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e5); }
      }
      if (s3 !== peg$FAILED) {
        s2 = [s2, s3];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 45) {
          s2 = peg$c6;
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e6); }
        }
        if (s2 !== peg$FAILED) {
          s3 = peg$parse__();
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      }
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      s2 = peg$parseDecimalIntegerLiteral();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f18();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseDecimalIntegerLiteral() {
    var s0, s1, s2, s3;

    if (input.charCodeAt(peg$currPos) === 48) {
      s0 = peg$c25;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e26); }
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseNonZeroDigit();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parseDecimalDigit();
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseDecimalDigit();
        }
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parseDecimalDigit() {
    var s0;

    if (peg$r1.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e27); }
    }

    return s0;
  }

  function peg$parseNonZeroDigit() {
    var s0;

    if (peg$r2.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e28); }
    }

    return s0;
  }

  function peg$parseBooleanLiteral() {
    var s0, s1;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 4).toLowerCase() === peg$c26) {
      s1 = input.substr(peg$currPos, 4);
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e29); }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f19();
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 5).toLowerCase() === peg$c27) {
        s1 = input.substr(peg$currPos, 5);
        peg$currPos += 5;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e30); }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f20();
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parseNullLiteral() {
    var s0, s1;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 4).toLowerCase() === peg$c28) {
      s1 = input.substr(peg$currPos, 4);
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e31); }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f21();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseCharacter() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$currPos;
    peg$silentFails++;
    s2 = peg$parseQuote();
    if (s2 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 92) {
        s2 = peg$c29;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e32); }
      }
    }
    peg$silentFails--;
    if (s2 === peg$FAILED) {
      s1 = undefined;
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseSourceCharacter();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f22();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseQuote() {
    var s0;

    s0 = peg$parseSingleQuote();
    if (s0 === peg$FAILED) {
      s0 = peg$parseDoubleQuote();
    }

    return s0;
  }

  function peg$parseSingleQuote() {
    var s0;

    if (input.charCodeAt(peg$currPos) === 39) {
      s0 = peg$c30;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e33); }
    }

    return s0;
  }

  function peg$parseDoubleQuote() {
    var s0;

    if (input.charCodeAt(peg$currPos) === 34) {
      s0 = peg$c31;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e34); }
    }

    return s0;
  }

  function peg$parseSourceCharacter() {
    var s0;

    if (input.length > peg$currPos) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e35); }
    }

    return s0;
  }

  function peg$parseLineTerminator() {
    var s0;

    if (peg$r3.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e36); }
    }

    return s0;
  }

  function peg$parseReservedKeyword() {
    var s0;

    s0 = peg$parseBooleanLiteral();
    if (s0 === peg$FAILED) {
      s0 = peg$parseNullLiteral();
    }

    return s0;
  }

  function peg$parse__() {
    var s0, s1;

    s0 = [];
    s1 = peg$parseWhiteSpace();
    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parseWhiteSpace();
    }

    return s0;
  }

  function peg$parseWhiteSpace() {
    var s0;

    if (input.charCodeAt(peg$currPos) === 9) {
      s0 = peg$c32;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e37); }
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseLineTerminator();
      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 11) {
          s0 = peg$c33;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e38); }
        }
        if (s0 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 12) {
            s0 = peg$c34;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e39); }
          }
          if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 32) {
              s0 = peg$c35;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e40); }
            }
            if (s0 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 160) {
                s0 = peg$c36;
                peg$currPos++;
              } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e41); }
              }
              if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 8203) {
                  s0 = peg$c37;
                  peg$currPos++;
                } else {
                  s0 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$e42); }
                }
                if (s0 === peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 65279) {
                    s0 = peg$c38;
                    peg$currPos++;
                  } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$e43); }
                  }
                }
              }
            }
          }
        }
      }
    }

    return s0;
  }


  const operators = {
    '&&': {
      functionName: 'and',
      rightAssociative: false,
      precedence: 6,
    },
    '||': {
      functionName: 'or',
      rightAssociative: false,
      precedence: 5,
    },
    '^': {
      functionName: 'exponentiate',
      rightAssociative: true,
      precedence: 4,
    },
    '*': {
      functionName: 'multiply',
      rightAssociative: false,
      precedence: 3,
    },
    '/': {
      functionName: 'divide',
      rightAssociative: false,
      precedence: 3,
    },
    '+': {
      functionName: 'add',
      rightAssociative: false,
      precedence: 2,
    },
    '-': {
      functionName: 'subtract',
      rightAssociative: false,
      precedence: 2,
    }
  };

  function stringLiteral(chars) {
      return {
        type: "literal",
        value: chars.join(""),
        dataType: "text",
        options: {
          length: chars.length
        }
      };
  }

  function optionalList(value) {
    return value !== null ? value[0] : [];
  }

  // Shunting Yard Algorithm to order operands by arithmetic precedence
  function infixToPostfixAst(tokens) {
    const operatorStack = [];
    const operandStack = [];

    tokens.forEach((token) => {
      if(token.type === 'operator') {
        while(operatorStack.length > 0) {
          if(operatorStack[operatorStack.length - 1].precedence < token.precedence) {
            break
          }

          let operator = operatorStack.pop();
          let operand2 = operandStack.pop();
          let operand1 = operandStack.pop();

          operandStack.push(buildOperatorNode(operator, operand1, operand2));
        }

        operatorStack.push(token);
      }
      else {
        operandStack.push(token);
      }
    });

    while(operatorStack.length > 0) {
      let operator = operatorStack.pop();
      let operand2 = operandStack.pop();
      let operand1 = operandStack.pop();

      operandStack.push(buildOperatorNode(operator, operand1, operand2));
    }

    return operandStack.pop()
  }

  function buildOperatorNode(operator, arg1, arg2) {
    return {
      type: "callExpression",
      id: operator.functionName,
      arguments: [arg1, arg2]
    }
  }

  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
}

  return {
    SyntaxError: peg$SyntaxError,
    parse: peg$parse
  };
})()
;

var timeParser = // Generated by Peggy 3.0.2.
//
// https://peggyjs.org/
(function() {

function peg$subclass(child, parent) {
  function C() { this.constructor = child; }
  C.prototype = parent.prototype;
  child.prototype = new C();
}

function peg$SyntaxError(message, expected, found, location) {
  var self = Error.call(this, message);
  // istanbul ignore next Check is a necessary evil to support older environments
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(self, peg$SyntaxError.prototype);
  }
  self.expected = expected;
  self.found = found;
  self.location = location;
  self.name = "SyntaxError";
  return self;
}

peg$subclass(peg$SyntaxError, Error);

function peg$padEnd(str, targetLength, padString) {
  padString = padString || " ";
  if (str.length > targetLength) { return str; }
  targetLength -= str.length;
  padString += padString.repeat(targetLength);
  return str + padString.slice(0, targetLength);
}

peg$SyntaxError.prototype.format = function(sources) {
  var str = "Error: " + this.message;
  if (this.location) {
    var src = null;
    var k;
    for (k = 0; k < sources.length; k++) {
      if (sources[k].source === this.location.source) {
        src = sources[k].text.split(/\r\n|\n|\r/g);
        break;
      }
    }
    var s = this.location.start;
    var offset_s = (this.location.source && (typeof this.location.source.offset === "function"))
      ? this.location.source.offset(s)
      : s;
    var loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
    if (src) {
      var e = this.location.end;
      var filler = peg$padEnd("", offset_s.line.toString().length, ' ');
      var line = src[s.line - 1];
      var last = s.line === e.line ? e.column : line.length + 1;
      var hatLen = (last - s.column) || 1;
      str += "\n --> " + loc + "\n"
          + filler + " |\n"
          + offset_s.line + " | " + line + "\n"
          + filler + " | " + peg$padEnd("", s.column - 1, ' ')
          + peg$padEnd("", hatLen, "^");
    } else {
      str += "\n at " + loc;
    }
  }
  return str;
};

peg$SyntaxError.buildMessage = function(expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function(expectation) {
      return "\"" + literalEscape(expectation.text) + "\"";
    },

    class: function(expectation) {
      var escapedParts = expectation.parts.map(function(part) {
        return Array.isArray(part)
          ? classEscape(part[0]) + "-" + classEscape(part[1])
          : classEscape(part);
      });

      return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]";
    },

    any: function() {
      return "any character";
    },

    end: function() {
      return "end of input";
    },

    other: function(expectation) {
      return expectation.description;
    }
  };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s
      .replace(/\\/g, "\\\\")
      .replace(/"/g,  "\\\"")
      .replace(/\0/g, "\\0")
      .replace(/\t/g, "\\t")
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r")
      .replace(/[\x00-\x0F]/g,          function(ch) { return "\\x0" + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return "\\x"  + hex(ch); });
  }

  function classEscape(s) {
    return s
      .replace(/\\/g, "\\\\")
      .replace(/\]/g, "\\]")
      .replace(/\^/g, "\\^")
      .replace(/-/g,  "\\-")
      .replace(/\0/g, "\\0")
      .replace(/\t/g, "\\t")
      .replace(/\n/g, "\\n")
      .replace(/\r/g, "\\r")
      .replace(/[\x00-\x0F]/g,          function(ch) { return "\\x0" + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return "\\x"  + hex(ch); });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = expected.map(describeExpectation);
    var i, j;

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ")
          + ", or "
          + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== undefined ? options : {};

  var peg$FAILED = {};
  var peg$source = options.grammarSource;

  var peg$startRuleFunctions = { Time: peg$parseTime };
  var peg$startRuleFunction = peg$parseTime;

  var peg$c0 = ":";
  var peg$c1 = ".";

  var peg$r0 = /^[0-9]/;

  var peg$e0 = peg$literalExpectation(":", false);
  var peg$e1 = peg$literalExpectation(".", false);
  var peg$e2 = peg$classExpectation([["0", "9"]], false, false);

  var peg$f0 = function(hour, minute, second, millisecond) {
    validateInput(hour, minute, second, millisecond);

    return {
      type: "literal",
      value: new Date(millisecond + second * 1000 + minute * 60 * 1000 + hour * 60 * 60 * 1000),
      dataType: "time",
      options: {}
    }
  };
  var peg$f1 = function() { return parseInt(text()) };
  var peg$f2 = function() { return parseInt(text()) };
  var peg$f3 = function() { return parseInt(text()) };
  var peg$f4 = function() { return parseInt(text()) };
  var peg$currPos = 0;
  var peg$savedPos = 0;
  var peg$posDetailsCache = [{ line: 1, column: 1 }];
  var peg$maxFailPos = 0;
  var peg$maxFailExpected = [];

  var peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function error(message, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text: text, ignoreCase: ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos];
    var p;

    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;

      return details;
    }
  }

  function peg$computeLocation(startPos, endPos, offset) {
    var startPosDetails = peg$computePosDetails(startPos);
    var endPosDetails = peg$computePosDetails(endPos);

    var res = {
      source: peg$source,
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
    if (offset && peg$source && (typeof peg$source.offset === "function")) {
      res.start = peg$source.offset(res.start);
      res.end = peg$source.offset(res.end);
    }
    return res;
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parseTime() {
    var s0, s1, s2, s3, s4, s5, s6, s7;

    s0 = peg$currPos;
    s1 = peg$parseHour();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 58) {
        s2 = peg$c0;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        { peg$fail(peg$e0); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseMinute();
        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 58) {
            s4 = peg$c0;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            { peg$fail(peg$e0); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseSecond();
            if (s5 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 46) {
                s6 = peg$c1;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                { peg$fail(peg$e1); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parseMillisecond();
                if (s7 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s0 = peg$f0(s1, s3, s5, s7);
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseHour() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$parseDecimalDigit();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseDecimalDigit();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f1();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseMinute() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$parseDecimalDigit();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseDecimalDigit();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f2();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseSecond() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = peg$parseDecimalDigit();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseDecimalDigit();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f3();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseMillisecond() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parseDecimalDigit();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseDecimalDigit();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseDecimalDigit();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f4();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseDecimalDigit() {
    var s0;

    if (peg$r0.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      { peg$fail(peg$e2); }
    }

    return s0;
  }


  function validateInput(hour, minute, second, millisecond) {
    if(hour > 23) {
      error("hour part needs to be under 24");
    }

    if(minute > 59) {
      error("minute part needs to be under 60");
    }

    if(second > 59) {
      error("second part needs to be under 60");
    }

    if(millisecond > 999) {
      error("millisecond part needs to be under 1000");
    }
  }

  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
}

  return {
    SyntaxError: peg$SyntaxError,
    parse: peg$parse
  };
})()
;

class FormulonRuntimeError extends Error {
  constructor(message, errorType, options) {
    super(message);
    this.errorType = errorType;
    this.options = options;
  }
}

const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

// Salesforce rounding works slightly different than JS rounding
// JS:
// Math.round(-1.5) => -1
// SF:
// ROUND(-1.5) => -2
const sfRound = (number, numDigits) => {
  if (number < 0) {
    return -1 * sfRound(number * -1, numDigits);
  }
  const multiplier = (10 ** numDigits);
  return Math.round(number * multiplier) / multiplier;
};

// private

const calculateNumberOptions = (number) => {
  const numberString = (number).toString().replace('-', '');
  if (numberString.indexOf('.') !== -1) {
    const splitted = numberString.split('.');
    return {
      length: splitted[0].length,
      scale: splitted[1].length,
    };
  }

  return {
    length: numberString.length,
    scale: 0,
  };
};

const coerceValue = (dataType, value, options) => {
  switch (dataType) {
    case 'number':
      return sfRound(value, options.scale);
    case 'text':
      return value.substring(0, options.length);
    default:
      return value;
  }
};

const geolocationFormat = (latitude, longitude) => {
  if ((!latitude || !longitude) && (latitude !== 0 && longitude !== 0)) return '';

  return `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
};

// public

const buildLiteralFromJs = (input) => {
  const base = { type: 'literal', value: input };

  if (input === null || input === undefined) {
    return Object.assign(
      base,
      { value: null, dataType: 'null', options: {} },
    );
  }

  const type = typeof (input);
  switch (typeof (input)) {
    case 'number':
      return Object.assign(
        base,
        { dataType: 'number', options: calculateNumberOptions(input) },
      );
    case 'string':
      return Object.assign(
        base,
        { dataType: 'text', options: { length: input.length } },
      );
    case 'boolean':
      return Object.assign(
        base,
        { dataType: 'checkbox', options: {} },
      );
    default:
      throw new TypeError(`Unsupported type '${type}'`);
  }
};

const parseTime = (input) => {
  try {
    return timeParser.parse(input);
  } catch (err) {
    if (err instanceof timeParser.SyntaxError) {
      return buildLiteralFromJs(null);
    }

    throw err;
  }
};

const buildErrorLiteral = (errorType, message, options) => ({
  type: 'error',
  errorType,
  message,
  ...options,
});

const buildDateLiteral = (yearOrDateObj, month, day) => {
  if (yearOrDateObj instanceof Date) {
    return buildDateLiteral(
      yearOrDateObj.getUTCFullYear(),
      yearOrDateObj.getUTCMonth() + 1,
      yearOrDateObj.getUTCDate(),
    );
  }

  return {
    type: 'literal',
    dataType: 'date',
    value: new Date(Date.UTC(yearOrDateObj, month - 1, day)),
    options: {},
  };
};

const buildDatetimeLiteral = (unixTimestamp) => ({
  type: 'literal',
  dataType: 'datetime',
  value: new Date(unixTimestamp),
  options: {},
});

const buildGeolocationLiteral = (latitude, longitude) => ({
  type: 'literal',
  dataType: 'geolocation',
  value: [latitude, longitude],
  options: {},
});

const buildTimeLiteral = (millisecondsFromMidnight) => ({
  type: 'literal',
  dataType: 'time',
  value: new Date(millisecondsFromMidnight),
  options: {},
});

const arrayUnique = (array) => array.reduce((p, c) => {
  if (p.indexOf(c) < 0) p.push(c);
  return p;
}, []);

const coerceLiteral = (input) => {
  if (input.value === undefined || input.value === null || Number.isNaN(input.value)) {
    return {
      type: 'literal',
      value: null,
      dataType: 'null',
      options: {},
    };
  }

  return {
    ...input,
    value: coerceValue(input.dataType, input.value, input.options),
  };
};

const handleFormulonError = (fn) => {
  try {
    return fn();
  } catch (err) {
    if (err instanceof FormulonRuntimeError) {
      return buildErrorLiteral(err.errorType, err.message, err.options);
    }

    throw err;
  }
};

// shamelessly stolen from https://stackoverflow.com/a/12793246/1087469
const addMonths = (date, numOfMonths) => {
  const newMonth = date.getUTCMonth() + numOfMonths;
  const newDate = new Date(Date.UTC(date.getUTCFullYear(), newMonth, date.getUTCDate()));

  if (date.getUTCDate() !== newDate.getUTCDate()) {
    newDate.setUTCDate(0);
  }

  return newDate;
};

const addDays = (date, numOfDays) => (
  new Date(date.getTime() + numOfDays * MILLISECONDS_IN_DAY)
);

const daysDifference = (date1, date2) => (
  (date1.getTime() - date2.getTime()) / MILLISECONDS_IN_DAY
);

const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string

const formatLiteral = (literal) => {
  if (!literal.value && literal.dataType !== 'null' && literal.value !== 0 && literal.value !== false && literal.value !== '') return '';

  switch (literal.dataType) {
    case 'null':
      return 'NULL';
    case 'number':
      return literal.value.toString();
    case 'text':
    case 'picklist':
      return `"${literal.value}"`;
    case 'multipicklist':
      return `[${literal.value.map((value) => `"${value}"`).join(', ')}]`;
    case 'checkbox':
      return literal.value.toString().toUpperCase();
    case 'date':
      return `${literal.value.getUTCFullYear()}-${(literal.value.getUTCMonth() + 1).toString().padStart(2, '0')}-${literal.value.getUTCDate().toString().padStart(2, '0')}`;
    case 'datetime':
      return literal.value.toISOString();
    case 'time':
      return literal.value.toISOString().split('T')[1].replace('Z', '');
    case 'geolocation':
      return geolocationFormat(literal.value[0], literal.value[1]);
    default:
      return undefined;
  }
};

class NotImplementedError extends FormulonRuntimeError {
  constructor(message, options) {
    super(message, 'NotImplementedError', options);
  }

  static throwError(fnName) {
    throw new NotImplementedError(`Function ${fnName} not implemented yet.`, { name: fnName });
  }
}

const capitalize = (s) => {
  if (Array.isArray(s)) {
    return s.map((elem) => capitalize(elem)).join(', ');
  }

  if (typeof s !== 'string') return '';

  return s.charAt(0).toUpperCase() + s.slice(1);
};

class ArgumentError extends FormulonRuntimeError {
  constructor(message, options) {
    super(message, 'ArgumentError', options);
  }

  static throwWrongType(fnName, expected, received) {
    const options = {
      function: fnName,
      expected,
      received,
    };

    const receivedStr = received || 'Non-Salesforce';

    throw new ArgumentError(`Incorrect parameter type for function '${fnName.toUpperCase()}()'. Expected ${capitalize(expected)}, received ${capitalize(receivedStr)}`, options);
  }

  static throwIncorrectNumberOfArguments(fnName, expected, received) {
    const options = {
      function: fnName,
      expected,
      received,
    };

    throw new ArgumentError(`Incorrect number of parameters for function '${fnName.toUpperCase()}()'. Expected ${expected}, received ${received}`, options);
  }
}

const STATIC_SESSION_ID = '00D3z000001eRlg!AQMAQC3Y4aM9sFux6SRWhyFcOUKin4taGaBxNMU8TN_R_1R0Y7ArI95eSyzQZVIlrnV_unTbmwHZlXex8xhlXz2kXZNP49Fa';

// Essential Functions

const sf$or = (...booleans) => {
  const result = booleans
    .map((boolean) => boolean.value)
    .reduce((previous, current) => previous || current);

  return buildLiteralFromJs(result);
};

const sf$equal = (value1, value2) => {
  switch (value1.dataType) {
    case 'date':
    case 'datetime':
      return buildLiteralFromJs(value1.value.getTime() === value2.value.getTime());
    default:
      return buildLiteralFromJs(value1.value === value2.value);
  }
};

const sf$unequal = (value1, value2) => buildLiteralFromJs(!sf$equal(value1, value2).value);

const sf$greaterThan = (value1, value2) => (
  buildLiteralFromJs(value1.value > value2.value)
);

const sf$greaterThanOrEqual = (value1, value2) => (
  buildLiteralFromJs(value1.value >= value2.value)
);

const sf$lessThan = (value1, value2) => (
  buildLiteralFromJs(value1.value < value2.value)
);

const sf$lessThanOrEqual = (value1, value2) => (
  buildLiteralFromJs(value1.value <= value2.value)
);

// Date & Time Functions

const sf$addmonths = (date, num) => (
  buildDateLiteral(addMonths(date.value, num.value))
);

const sf$date = (year, month, day) => (
  buildDateLiteral(year.value, month.value, day.value)
);

const sf$datevalue = (expression) => (
  buildDateLiteral(new Date(Date.parse(expression.value)))
);

const sf$datetimevalue = (expression) => (
  buildDatetimeLiteral(Date.parse(`${expression.value}Z`))
);

const sf$day = (date) => (
  buildLiteralFromJs(date.value.getUTCDate())
);

const sf$hour = (expression) => (
  buildLiteralFromJs(expression.value.getUTCHours())
);

const sf$millisecond = (expression) => (
  buildLiteralFromJs(expression.value.getUTCMilliseconds())
);

const sf$minute = (expression) => (
  buildLiteralFromJs(expression.value.getUTCMinutes())
);

const sf$month = (date) => (
  buildLiteralFromJs(date.value.getUTCMonth() + 1)
);

const sf$now = () => (
  buildDatetimeLiteral(new Date().getTime())
);

const sf$second = (expression) => (
  buildLiteralFromJs(expression.value.getUTCSeconds())
);

const sf$timenow = () => {
  const millisecondsInDay = 24 * 60 * 60 * 1000;

  return buildTimeLiteral(new Date().getTime() % millisecondsInDay);
};

const sf$timevalue = (expression) => parseTime(expression.value);

const sf$today = () => buildDateLiteral(new Date());

const sf$weekday = (date) => buildLiteralFromJs(date.value.getUTCDay() + 1);

const sf$year = (date) => buildLiteralFromJs(date.value.getUTCFullYear());

// Logical Functions

const sf$and = (...booleans) => {
  const result = booleans
    .map((boolean) => boolean.value)
    .reduce((previous, current) => previous && current);

  return buildLiteralFromJs(result);
};

const sf$blankvalue = (expression, substituteExpression) => (
  expression.dataType === 'null' || expression.value === '' ? substituteExpression : expression
);

const sf$case = (expression, ...values) => {
  const lastValueIndex = values.length - 1;
  if (lastValueIndex <= 0) {
    const options = {
      function: 'case',
      expected: 4,
      received: lastValueIndex + 2,
    };
    throw new ArgumentError(`Incorrect number of parameters for function '${options.function.toUpperCase()}()'. Expected ${options.expected}+, received ${options.received}`, options);
  }

  if (lastValueIndex % 2 !== 0) {
    const options = {
      function: 'case',
      expected: lastValueIndex + 1,
      received: lastValueIndex + 2,
    };
    throw new ArgumentError(`Incorrect number of parameters for function '${options.function.toUpperCase()}()'. Expected ${options.expected}, received ${options.received}`, options);
  }
  for (let index = 0; index < lastValueIndex; index += 2) {
    if (sf$equal(values[index], expression).value) {
      return values[index + 1];
    }
  }
  return values[lastValueIndex];
};

const sf$if = (logicalTest, valueIfTrue, valueIfFalse) => (
  logicalTest.value ? valueIfTrue : valueIfFalse
);

const sf$isblank = (expression) => buildLiteralFromJs(expression.dataType === 'null' || expression.value === '');

const sf$isnull = (expression) => buildLiteralFromJs(expression.dataType === 'null');

/* eslint-disable no-unused-vars */
const sf$isnumber = (_text) => {
  NotImplementedError.throwError('isnumber');
};
/* eslint-enable no-unused-vars */

const sf$not = (logical) => buildLiteralFromJs(!logical.value);

const sf$nullvalue = (expression, substituteExpression) => (
  expression.dataType === 'null' ? substituteExpression : expression
);

// Math Operators

/* eslint-disable consistent-return */
const sf$add = (value1, value2) => {
  switch ([value1.dataType, value2.dataType].join(' ')) {
    case 'date number':
      return buildDateLiteral(addDays(value1.value, value2.value));
    case 'number date':
      return buildDateLiteral(addDays(value2.value, value1.value));
    case 'time number':
      return buildTimeLiteral(value1.value.getTime() + value2.value);
    case 'number time':
      return buildTimeLiteral(value1.value + value2.value.getTime());
    case 'datetime number':
      return buildDatetimeLiteral(addDays(value1.value, value2.value));
    case 'number datetime':
      return buildDatetimeLiteral(addDays(value2.value, value1.value));
    case 'number number':
      return buildLiteralFromJs(
        new Decimal__default["default"](value1.value)
          .plus(new Decimal__default["default"](value2.value))
          .toNumber(),
      );
    case 'text text':
      return buildLiteralFromJs(value1.value + value2.value);
    case 'text null':
      return value1;
    default:
      ArgumentError.throwWrongType('add', 'number', value2.dataType);
  }
};

const sf$subtract = (value1, value2) => {
  switch ([value1.dataType, value2.dataType].join(' ')) {
    case 'date number':
      return buildDateLiteral(addDays(value1.value, -1 * value2.value));
    case 'time number':
      return buildTimeLiteral(value1.value.getTime() + -1 * value2.value);
    case 'datetime number':
      return buildDatetimeLiteral(addDays(value1.value, -1 * value2.value));
    case 'date date':
    case 'datetime datetime':
      return buildLiteralFromJs(daysDifference(value1.value, value2.value));
    case 'time time':
      return buildLiteralFromJs(value1.value.getTime() - value2.value.getTime());
    case 'number number':
      return buildLiteralFromJs(
        new Decimal__default["default"](value1.value)
          .minus(new Decimal__default["default"](value2.value))
          .toNumber(),
      );
    case 'text text':
      return buildLiteralFromJs(value1.value - value2.value);
    default:
      ArgumentError.throwWrongType('subtract', 'number', value2.dataType);
  }
};
/* eslint-enable consistent-return */

const sf$multiply = (value1, value2) => {
  if ([value1.dataType, value2.dataType].join(' ') !== 'number number') {
    ArgumentError.throwWrongType('multiply', 'number', value2.dataType);
  }

  return buildLiteralFromJs(
    new Decimal__default["default"](value1.value)
      .times(new Decimal__default["default"](value2.value))
      .toNumber(),
  );
};

const sf$divide = (value1, value2) => {
  if ([value1.dataType, value2.dataType].join(' ') !== 'number number') {
    ArgumentError.throwWrongType('divide', 'number', value2.dataType);
  }

  return buildLiteralFromJs(
    new Decimal__default["default"](value1.value)
      .dividedBy(new Decimal__default["default"](value2.value))
      .toNumber(),
  );
};

const sf$exponentiate = (value1, value2) => {
  if ([value1.dataType, value2.dataType].join(' ') !== 'number number') {
    ArgumentError.throwWrongType('exponentiate', 'number', value2.dataType);
  }

  if (value2.options.scale !== 0) {
    ArgumentError.throwWrongType('exponentiate', 'integer', value2.dataType);
  }

  return buildLiteralFromJs(
    new Decimal__default["default"](value1.value)
      .toPower(new Decimal__default["default"](value2.value))
      .toNumber(),
  );
};
// Math Functions

const sf$abs = (number) => buildLiteralFromJs(Math.abs(number.value));

const sf$ceiling = (number) => {
  if (number.value < 0) {
    return buildLiteralFromJs(-1 * Math.ceil(-1 * number.value));
  }

  return buildLiteralFromJs(Math.ceil(number.value));
};

const sf$distance = (location1, location2, unit) => {
  const distanceUnit = unit.value;

  if (distanceUnit !== 'km' && distanceUnit !== 'mi') {
    const options = {
      function: 'distance',
      expected: ['km', 'mi'],
      received: distanceUnit,
    };
    throw new ArgumentError(`Incorrect parameter value for function 'DISTANCE()'. Expected 'mi'/'km', received '${distanceUnit}'`, options);
  }

  const [lat1, lon1] = location1.value;
  const [lat2, lon2] = location2.value;

  // haversine algorithm taken from https://www.movable-type.co.uk/scripts/latlong.html
  if ((lat1 === lat2) && (lon1 === lon2)) {
    return buildLiteralFromJs(0);
  }

  // earth radius in meters, reverse engineered from
  // Salesforce DISTANCE(GEOLOCATION(0,0), GEOLOCATION(0, 180), 'km')
  const earthRadius = 6371009;
  const phi1 = (lat1 * Math.PI) / 180;
  const phi2 = (lat2 * Math.PI) / 180;
  const deltaPhi = ((lat2 - lat1) * Math.PI) / 180;
  const deltaLambda = ((lon2 - lon1) * Math.PI) / 180;

  const a = Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2)
              + Math.cos(phi1) * Math.cos(phi2)
              * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = (earthRadius * c) / 1000;

  if (distanceUnit === 'mi') {
    return buildLiteralFromJs(d / 1.609344);
  }

  return buildLiteralFromJs(d);
};

const sf$exp = (number) => buildLiteralFromJs(Math.exp(number.value));

const sf$floor = (number) => {
  if (number.value < 0) {
    return buildLiteralFromJs(-1 * Math.floor(-1 * number.value));
  }

  return buildLiteralFromJs(Math.floor(number.value));
};

const sf$geolocation = (latitude, longitude) => (
  buildGeolocationLiteral(latitude.value, longitude.value)
);

const sf$ln = (number) => buildLiteralFromJs(Math.log(number.value));

const sf$log = (number) => buildLiteralFromJs(Math.log10(number.value));

const sf$max = (...numbers) => {
  const values = numbers.map((v) => v.value);
  return buildLiteralFromJs(Math.max(...values));
};

const sf$mceiling = (number) => buildLiteralFromJs(Math.ceil(number.value));

const sf$mfloor = (number) => buildLiteralFromJs(Math.floor(number.value));

const sf$min = (...numbers) => {
  const values = numbers.map((v) => v.value);
  return buildLiteralFromJs(Math.min(...values));
};

const sf$mod = (number, divisor) => buildLiteralFromJs(number.value % divisor.value);

const sf$round = (number, numDigits) => (
  buildLiteralFromJs(sfRound(number.value, numDigits.value))
);

const sf$sqrt = (number) => buildLiteralFromJs(Math.sqrt(number.value));

// Text Functions

const sf$begins = (text, compareText) => (
  buildLiteralFromJs(text.value.startsWith(compareText.value))
);

const sf$br = () => buildLiteralFromJs('\n');

const sf$casesafeid = (id) => {
  let suffix = '';

  [0, 1, 2].forEach((i) => {
    let flags = 0;

    [0, 1, 2, 3, 4].forEach((j) => {
      const c = id.value[i * 5 + j];
      if (c.toUpperCase() === c && c >= 'A' && c <= 'Z') {
        /* eslint no-bitwise: ["error", { "allow": ["<<"] }] */
        flags += 1 << j;
        /* eslint no-bitwise: ["error", { "allow": ["<<"] }] */
      }
    });
    suffix += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ012345'[flags];
  });

  return buildLiteralFromJs(id.value + suffix);
};

const sf$concat = (text1, text2) => buildLiteralFromJs(text1.value + text2.value);

const sf$contains = (text, compareText) => (
  buildLiteralFromJs(text.value.includes(compareText.value))
);

const sf$find = (searchText, text, startNum = buildLiteralFromJs(1)) => {
  if (startNum.value <= 0 || searchText.value === '') {
    return buildLiteralFromJs(0);
  }

  const textToSearchIn = text.value.substring(startNum.value - 1);
  return buildLiteralFromJs(textToSearchIn.indexOf(searchText.value) + 1);
};

const sf$getsessionid = () => buildLiteralFromJs(STATIC_SESSION_ID);

const sf$hyperlink = (url, friendlyName, target = null) => {
  const targetString = target ? ` target="${target.value}"` : '';

  return buildLiteralFromJs(`<a href="${url.value}"${targetString}>${friendlyName.value}</a>`);
};

const sf$image = (imageUrl, alternateText, height = null, width = null) => {
  const heightString = height ? ` height="${height.value}"` : '';
  const widthString = width ? ` width="${width.value}"` : '';
  return buildLiteralFromJs(`<img src="${imageUrl.value}" alt="${alternateText.value}"${heightString}${widthString}/>`);
};

const sf$includes = (multiselectPicklistField, textLiteral) => (
  buildLiteralFromJs(multiselectPicklistField.value.includes(textLiteral.value))
);

const sf$ispickval = (picklistField, textLiteral) => (
  buildLiteralFromJs(picklistField.value === textLiteral.value)
);

const sf$mid = (text, startNum, numChars) => (
  buildLiteralFromJs(text.value.substr(startNum.value - 1, numChars.value))
);

const sf$left = (text, numChars) => sf$mid(text, buildLiteralFromJs(1), numChars);

const sf$len = (text) => buildLiteralFromJs(text.value.length);

/* eslint-disable no-unused-vars */
const sf$lower = (text, _locale) => buildLiteralFromJs(text.value.toLowerCase());
/* eslint-enable no-unused-vars */

const sf$lpad = (text, paddedLength, padString) => {
  if (padString == null) {
    return text;
  } if (paddedLength.value < text.value.length) {
    return sf$left(text, paddedLength);
  }
  const maxPadding = padString.value.repeat(paddedLength.value);
  return buildLiteralFromJs((maxPadding + text.value).slice(-paddedLength.value));
};

const sf$right = (text, numChars) => (
  buildLiteralFromJs(text.value.substr(text.value.length - numChars.value))
);

const sf$rpad = (text, paddedLength, padString) => {
  if (padString == null) {
    return text;
  } if (paddedLength.value < text.value.length) {
    return sf$left(text, paddedLength);
  }
  const maxPadding = padString.value.repeat(paddedLength.value);
  return buildLiteralFromJs((text.value + maxPadding).substr(0, paddedLength.value));
};

const sf$substitute = (text, oldText, newText) => buildLiteralFromJs(text.value.replace(new RegExp(escapeRegExp(oldText.value), 'g'), newText.value));

const sf$text = (value) => {
  if (value.dataType === 'datetime') {
    return buildLiteralFromJs(formatLiteral(value).replace('T', ' ').replace(/\.\d{3}/, ''));
  }

  if (value.dataType === 'picklist') {
    return buildLiteralFromJs(value.value);
  }

  return buildLiteralFromJs(formatLiteral(value));
};

const sf$trim = (text) => buildLiteralFromJs(text.value.trim());

/* eslint-disable no-unused-vars */
const sf$upper = (text, _locale) => buildLiteralFromJs(text.value.toUpperCase());
/* eslint-enable no-unused-vars */

/* eslint-disable no-unused-vars */
const sf$value = (text) => {
  const parsedValue = parseFloat(text.value);

  if (parsedValue) {
    return buildLiteralFromJs(parsedValue);
  }

  return buildLiteralFromJs(null);
};
/* eslint-enable no-unused-vars */

// Advanced Functions

/* eslint-disable no-unused-vars */
const sf$currencyrate = (_isoCode) => {
  NotImplementedError.throwError('currencyrate');
};
/* eslint-enable no-unused-vars */

const sf$regex = (text, regexText) => {
  const r = new RegExp(`^${regexText.value}$`);
  return buildLiteralFromJs(r.exec(text.value) != null);
};

var functions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sf$or: sf$or,
  sf$equal: sf$equal,
  sf$unequal: sf$unequal,
  sf$greaterThan: sf$greaterThan,
  sf$greaterThanOrEqual: sf$greaterThanOrEqual,
  sf$lessThan: sf$lessThan,
  sf$lessThanOrEqual: sf$lessThanOrEqual,
  sf$addmonths: sf$addmonths,
  sf$date: sf$date,
  sf$datevalue: sf$datevalue,
  sf$datetimevalue: sf$datetimevalue,
  sf$day: sf$day,
  sf$hour: sf$hour,
  sf$millisecond: sf$millisecond,
  sf$minute: sf$minute,
  sf$month: sf$month,
  sf$now: sf$now,
  sf$second: sf$second,
  sf$timenow: sf$timenow,
  sf$timevalue: sf$timevalue,
  sf$today: sf$today,
  sf$weekday: sf$weekday,
  sf$year: sf$year,
  sf$and: sf$and,
  sf$blankvalue: sf$blankvalue,
  sf$case: sf$case,
  sf$if: sf$if,
  sf$isblank: sf$isblank,
  sf$isnull: sf$isnull,
  sf$isnumber: sf$isnumber,
  sf$not: sf$not,
  sf$nullvalue: sf$nullvalue,
  sf$add: sf$add,
  sf$subtract: sf$subtract,
  sf$multiply: sf$multiply,
  sf$divide: sf$divide,
  sf$exponentiate: sf$exponentiate,
  sf$abs: sf$abs,
  sf$ceiling: sf$ceiling,
  sf$distance: sf$distance,
  sf$exp: sf$exp,
  sf$floor: sf$floor,
  sf$geolocation: sf$geolocation,
  sf$ln: sf$ln,
  sf$log: sf$log,
  sf$max: sf$max,
  sf$mceiling: sf$mceiling,
  sf$mfloor: sf$mfloor,
  sf$min: sf$min,
  sf$mod: sf$mod,
  sf$round: sf$round,
  sf$sqrt: sf$sqrt,
  sf$begins: sf$begins,
  sf$br: sf$br,
  sf$casesafeid: sf$casesafeid,
  sf$concat: sf$concat,
  sf$contains: sf$contains,
  sf$find: sf$find,
  sf$getsessionid: sf$getsessionid,
  sf$hyperlink: sf$hyperlink,
  sf$image: sf$image,
  sf$includes: sf$includes,
  sf$ispickval: sf$ispickval,
  sf$mid: sf$mid,
  sf$left: sf$left,
  sf$len: sf$len,
  sf$lower: sf$lower,
  sf$lpad: sf$lpad,
  sf$right: sf$right,
  sf$rpad: sf$rpad,
  sf$substitute: sf$substitute,
  sf$text: sf$text,
  sf$trim: sf$trim,
  sf$upper: sf$upper,
  sf$value: sf$value,
  sf$currencyrate: sf$currencyrate,
  sf$regex: sf$regex
});

const minNumOfParams = (expectedMinNumOfParams) => (fnName) => (params) => {
  if (params.length < expectedMinNumOfParams) {
    ArgumentError.throwIncorrectNumberOfArguments(fnName, expectedMinNumOfParams, params.length);
  }
};

const maxNumOfParams = (expectedMaxNumOfParams) => (fnName) => (params) => {
  if (params.length > expectedMaxNumOfParams) {
    ArgumentError.throwIncorrectNumberOfArguments(fnName, expectedMaxNumOfParams, params.length);
  }
};

const paramTypes = (...paramTypeList) => (fnName) => (params) => {
  const comparableArray = params.map((literal, index) => [
    literal.dataType, paramTypeList[index] || paramTypeList[paramTypeList.length - 1],
  ]);

  // fill with last element of params, parameterlist is smaller than params

  comparableArray.forEach(([received, expected]) => {
    // allow null input in all functions
    if (received !== 'null') {
      if (Array.isArray(expected)) {
        if (expected.indexOf(received) === -1) {
          ArgumentError.throwWrongType(fnName, expected, received);
        }
      } else if (received !== expected) {
        ArgumentError.throwWrongType(fnName, expected, received);
      }
    }
  });
};

const sameParamType = () => (fnName) => (params) => {
  const nonNullParams = params.filter((param) => param.dataType !== 'null');

  if (nonNullParams.length > 0) {
    nonNullParams.reduce((acc, current) => {
      if (acc.dataType !== current.dataType) {
        ArgumentError.throwWrongType(fnName, acc.dataType, current.dataType);
      }
      return current;
    });
  }
};

// special validation, to assure that all cases in a CASE statement match the input data type
const caseParams = () => (fnName) => (params) => {
  const expectedType = params[0].dataType === 'picklist' ? 'text' : params[0].dataType;

  const cases = params.filter((_elem, index) => (
    index % 2 === 1 && index !== (params.length - 1)
  ));

  const differentCase = cases.find((elem) => elem.dataType !== expectedType);

  if (differentCase) {
    ArgumentError.throwWrongType(fnName, expectedType, differentCase.dataType);
  }
};

class NoFunctionError extends FormulonRuntimeError {
  constructor(message, options) {
    super(message, 'NoFunctionError', options);
  }
}

const existingFunctions = {
  abs: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('number')],
    returnType: 'number',
  },
  add: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['number', 'text', 'date', 'datetime', 'time'], ['number', 'text', 'date', 'datetime', 'time'])],
    returnType: ['number', 'text', 'date', 'datetime', 'time'],
  },
  addmonths: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['date', 'datetime'], ['number'])],
    returnType: ['date', 'datetime'],
  },
  and: {
    validations: [minNumOfParams(1), paramTypes('checkbox')],
    returnType: 'checkbox',
  },
  begins: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('text', 'text')],
    returnType: 'checkbox',
  },
  blankvalue: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['text', 'number', 'date', 'datetime', 'geolocation']), sameParamType()],
    returnType: ['text', 'number'],
  },
  br: {
    validations: [minNumOfParams(0), maxNumOfParams(0)],
    returnType: 'text',
  },
  case: {
    validations: [minNumOfParams(4), paramTypes(['text', 'number', 'picklist', 'date', 'datetime']), caseParams()],
    returnType: ['text', 'number', 'date', 'datetime'],
  },
  casesafeid: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('text')],
    returnType: 'text',
  },
  ceiling: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('number')],
    returnType: 'number',
  },
  contains: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('text', 'text')],
    returnType: 'checkbox',
  },
  currencyrate: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('text')],
    returnType: 'text',
  },
  date: {
    validations: [minNumOfParams(3), maxNumOfParams(3), paramTypes('number', 'number', 'number')],
    returnType: 'date',
  },
  datetimevalue: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('text', 'date', 'datetime')],
    returnType: 'datetime',
  },
  datevalue: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes(['text', 'date', 'datetime'])],
    returnType: 'date',
  },
  day: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('date')],
    returnType: 'number',
  },
  distance: {
    validations: [minNumOfParams(3), maxNumOfParams(3), paramTypes('geolocation', 'geolocation', 'text')],
    returnType: 'number',
  },
  divide: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('number', 'number')],
    returnType: 'number',
  },
  equal: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['text', 'number', 'date', 'datetime', 'checkbox']), sameParamType()],
    returnType: 'checkbox',
  },
  exp: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('number')],
    returnType: 'number',
  },
  exponentiate: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('number', 'number')],
    returnType: 'number',
  },
  find: {
    validations: [minNumOfParams(2), maxNumOfParams(3), paramTypes('text', 'text', 'number')],
    returnType: 'number',
  },
  floor: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('number')],
    returnType: 'number',
  },
  geolocation: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('number', 'number')],
    returnType: 'geolocation',
  },
  getsessionid: {
    validations: [minNumOfParams(0), maxNumOfParams(0)],
    returnType: 'text',
  },
  greaterThan: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['number', 'date', 'datetime']), sameParamType()],
    returnType: 'checkbox',
  },
  greaterThanOrEqual: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['number', 'date', 'datetime'])],
    returnType: 'checkbox',
  },
  hour: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('datetime')],
    returnType: 'number',
  },
  hyperlink: {
    validations: [minNumOfParams(2), maxNumOfParams(3), paramTypes('text', 'text', 'text')],
    returnType: 'text',
  },
  if: {
    validations: [minNumOfParams(3), maxNumOfParams(3), paramTypes('checkbox', ['text', 'number', 'date', 'datetime', 'checkbox', 'geolocation'], ['text', 'number', 'date', 'datetime', 'checkbox', 'geolocation'])],
    returnType: ['text', 'number', 'date', 'datetime', 'checkbox', 'geolocation'],
  },
  image: {
    validations: [minNumOfParams(2), maxNumOfParams(4), paramTypes('text', 'text', 'number', 'number')],
    returnType: 'text',
  },
  includes: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('multipicklist', 'text')],
    returnType: 'checkbox',
  },
  isblank: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes(['text', 'number', 'date', 'datetime', 'geolocation'])],
    returnType: 'checkbox',
  },
  isnull: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes(['text', 'number', 'date', 'datetime', 'geolocation'])],
    returnType: 'checkbox',
  },
  ispickval: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('picklist', 'text')],
    returnType: 'checkbox',
  },
  isnumber: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('text')],
    returnType: 'checkbox',
  },
  left: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('text', 'number')],
    returnType: 'text',
  },
  len: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('text')],
    returnType: 'number',
  },
  lessThan: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['number', 'date', 'datetime']), sameParamType()],
    returnType: 'checkbox',
  },
  lessThanOrEqual: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['number', 'date', 'datetime']), sameParamType()],
    returnType: 'checkbox',
  },
  ln: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('number')],
    returnType: 'number',
  },
  log: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('number')],
    returnType: 'checkbox',
  },
  lower: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('text')],
    returnType: 'text',
  },
  lpad: {
    validations: [minNumOfParams(2), maxNumOfParams(3), paramTypes('text', 'number', 'text')],
    returnType: 'text',
  },
  max: {
    validations: [minNumOfParams(1), paramTypes('number')],
    returnType: 'number',
  },
  mceiling: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('number')],
    returnType: 'number',
  },
  mfloor: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('number')],
    returnType: 'number',
  },
  mid: {
    validations: [minNumOfParams(3), maxNumOfParams(3), paramTypes('text', 'number', 'number')],
    returnType: 'number',
  },
  millisecond: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('datetime')],
    returnType: 'number',
  },
  min: {
    validations: [minNumOfParams(1), paramTypes('number')],
    returnType: 'number',
  },
  minute: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('datetime')],
    returnType: 'number',
  },
  mod: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('number', 'number')],
    returnType: 'number',
  },
  month: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('date')],
    returnType: 'number',
  },
  multiply: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('number', 'number')],
    returnType: 'number',
  },
  not: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('checkbox')],
    returnType: 'checkbox',
  },
  now: {
    validations: [minNumOfParams(0), maxNumOfParams(0)],
    returnType: 'datetime',
  },
  nullvalue: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['text', 'number', 'date', 'datetime', 'geolocation']), sameParamType()],
    returnType: ['text', 'number'],
  },
  or: {
    validations: [minNumOfParams(1), paramTypes('checkbox')],
    returnType: 'checkbox',
  },
  regex: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('text', 'text')],
    returnType: 'text',
  },
  right: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('text', 'number')],
    returnType: 'text',
  },
  round: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes('number', 'number')],
    returnType: 'number',
  },
  rpad: {
    validations: [minNumOfParams(2), maxNumOfParams(3), paramTypes('text', 'number', 'text')],
    returnType: 'text',
  },
  second: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('datetime')],
    returnType: 'number',
  },
  sqrt: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('number')],
    returnType: 'number',
  },
  subtract: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['number', 'date', 'datetime', 'time'], ['number', 'date', 'datetime', 'time'])],
    returnType: ['number', 'date', 'datetime', 'time'],
  },
  substitute: {
    validations: [minNumOfParams(3), maxNumOfParams(3), paramTypes('text', 'text', 'text')],
    returnType: 'text',
  },
  text: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes(['number', 'date', 'datetime', 'picklist', 'time'])],
    returnType: 'text',
  },
  timenow: {
    validations: [minNumOfParams(0), maxNumOfParams(0)],
    returnType: 'time',
  },
  timevalue: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('text')],
    returnType: 'time',
  },
  today: {
    validations: [minNumOfParams(0), maxNumOfParams(0)],
    returnType: 'date',
  },
  trim: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('text')],
    returnType: 'text',
  },
  unequal: {
    validations: [minNumOfParams(2), maxNumOfParams(2), paramTypes(['text', 'number', 'date', 'datetime', 'checkbox']), sameParamType()],
    returnType: 'checkbox',
  },
  upper: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('text')],
    returnType: 'text',
  },
  value: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('text')],
    returnType: 'number',
  },
  weekday: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('date')],
    returnType: 'number',
  },
  year: {
    validations: [minNumOfParams(1), maxNumOfParams(1), paramTypes('date')],
    returnType: 'number',
  },
};

const dispatch = (name, args) => handleFormulonError(() => {
  const runTimeError = args.find((arg) => arg.type === 'error');

  if (runTimeError) {
    return runTimeError;
  }

  const existingFunction = existingFunctions[name];

  if (existingFunction) {
    existingFunction.validations.forEach(
      (validateFn) => validateFn(name)(args),
    );

    return functions[`sf$${name}`](...args);
  }

  throw new NoFunctionError(`Unknown function ${name.toUpperCase()}. Check spelling.`, { function: name });
});

class ReferenceError extends FormulonRuntimeError {
  constructor(message, options) {
    super(message, 'ReferenceError', options);
  }
}

const traverseAndThrow = (ast) => {
  switch (ast.type) {
    case 'callExpression':
      return dispatch(ast.id, ast.arguments.map((arg) => traverseAndThrow(arg)));
    case 'identifier':
      throw new ReferenceError(`Field ${ast.name} does not exist. Check spelling.`, { identifier: ast.name });
    default:
      return ast;
  }
};

// public

const build = (formula) => {
  try {
    return salesforceParser.parse(formula == null ? '' : formula.trim());
  } catch (err) {
    if (err instanceof salesforceParser.SyntaxError) {
      return buildErrorLiteral('SyntaxError', 'Syntax error.', {});
    }

    throw err;
  }
};

const traverse = (ast) => handleFormulonError(() => traverseAndThrow(ast));

const extract$1 = (ast, state = []) => {
  switch (ast.type) {
    case 'callExpression':
      return ast.arguments.map((arg) => extract$1(arg, state)).reduce((a, b) => a.concat(b), []);
    case 'identifier':
      return state.concat(ast.name);
    default:
      return state;
  }
};

const replace = (ast, replacement) => {
  if (ast.type === 'callExpression') {
    return {
      type: 'callExpression',
      id: ast.id,
      arguments: ast.arguments.map((arg) => replace(arg, replacement)),
    };
  }

  if (ast.type === 'identifier' && replacement[ast.name]) {
    return {

      ...replacement[ast.name],
      type: 'literal',
    };
  }

  return ast;
};

const parse = (formula, substitutions = {}) => {
  if (formula == null || formula.trim() === '') {
    return buildLiteralFromJs('');
  }

  const ast = build(formula);

  const coercedSubstitutions = Object.keys(substitutions).reduce((previous, current) => (
    {
      ...previous,
      [current]: coerceLiteral(substitutions[current]),
    }
  ), {});

  return traverse(replace(ast, coercedSubstitutions));
};

const extract = (formula) => {
  if (formula == null || formula.trim() === '') {
    return [];
  }

  const ast = build(formula);
  return arrayUnique(extract$1(ast));
};

const ast = (formula) => {
  if (formula == null || formula.trim() === '') {
    return {};
  }

  return build(formula);
};

const toString = (literal) => formatLiteral(literal);

exports.ast = ast;
exports.extract = extract;
exports.parse = parse;
exports.toString = toString;
